/**
 *  Функция для приведения вывода числа, как цены
 *  opt - хеш параметров
 *      price - число, которое нужно представить как цену
        kop - флаг, что нужно показать копейки
        sign - признак и одновременно символ валюты
        no_tags - флаг форматирования без тегов
 */

function toPrice(opt) {
    var price = opt.price.toFixed(2);

    var rub = Math.floor(price).toString();
    var kop = Math.floor((price - parseInt(price) + 0.001) * 100).toString();

    var l = rub.length;
    var i = 0;
    var html = '';

    while (i < l) {
        var k = ((i == 0) && (l % 3 > 0))
            ? l % 3
            : 3;
        if (i + k < l) {
            if(opt.no_tags){
                html += rub.substr(i, k) + ' ';
            }else{
                html += '<span>' + rub.substr(i, k) + '</span>';
            }

        } else {
            html += rub.substr(i, k);
        }
        i += k;
    }

    if(opt.kop){
        if (kop.length < 2)
            kop = '0' + kop;
        html += ',' + kop;
    }

    if(opt.sign){
        if(opt.no_tags){
            html += ' '+ opt.sign;
        }else{
            html += ' <ins>'+ opt.sign +'</ins>';
        }
    }
    return html;
}

export default toPrice;